/* Cantra theme — lightweight interactions (no dependencies) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* -------- Mobile menu / header drawer -------- */
  function initHeader() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var drawer = document.querySelector('[data-mobile-drawer]');
    if (!toggle || !drawer) return;
    var body = document.body;
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      body.classList.remove('drawer-open');
    }
    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      body.classList.add('drawer-open');
    }
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (drawer.classList.contains('is-open')) { close(); } else { open(); }
    });
    drawer.addEventListener('click', function (e) {
      // close on the X button (or its inner icon), or when tapping the dark backdrop
      if (e.target.closest('[data-drawer-close]') || e.target === drawer) close();
    });
    // tapping any menu link closes the drawer
    drawer.querySelectorAll('a[href]').forEach(function (a) {
      a.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* -------- Search toggle (mobile) -------- */
  function initSearch() {
    document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.querySelector(btn.getAttribute('data-search-toggle'));
        if (!target) return;
        var open = target.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
        if (open) { var i = target.querySelector('input'); if (i) i.focus(); }
      });
    });
  }

  /* -------- Generic slider (hero, testimonials) -------- */
  function initSliders() {
    document.querySelectorAll('[data-slider]').forEach(function (root) {
      var track = root.querySelector('[data-slides]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
      if (!track || slides.length === 0) return;
      var prev = root.querySelector('[data-slide-prev]');
      var next = root.querySelector('[data-slide-next]');
      var dotsWrap = root.querySelector('[data-slide-dots]');
      var autoplay = parseInt(root.getAttribute('data-autoplay') || '0', 10);
      var index = 0, timer = null;

      var dots = [];
      if (dotsWrap) {
        slides.forEach(function (_, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'slider-dot';
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          b.addEventListener('click', function () { go(i); });
          dotsWrap.appendChild(b);
          dots.push(b);
        });
      }

      function render() {
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
        slides.forEach(function (s, i) { s.setAttribute('aria-hidden', String(i !== index)); });
      }
      function go(i) { index = (i + slides.length) % slides.length; render(); restart(); }
      function restart() {
        if (!autoplay || reduceMotion) return;
        clearInterval(timer);
        timer = setInterval(function () { go(index + 1); }, autoplay);
      }

      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      root.addEventListener('mouseenter', function () { clearInterval(timer); });
      root.addEventListener('mouseleave', restart);

      if (slides.length < 2) {
        if (prev) prev.style.display = 'none';
        if (next) next.style.display = 'none';
        if (dotsWrap) dotsWrap.style.display = 'none';
      }
      render();
      restart();
    });
  }

  /* -------- Announcement bar rotation -------- */
  function initAnnouncement() {
    document.querySelectorAll('[data-announce]').forEach(function (bar) {
      var items = bar.querySelectorAll('[data-announce-item]');
      if (items.length < 2 || reduceMotion) return;
      var i = 0;
      items[0].classList.add('is-active');
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 4000);
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    initHeader();
    initSearch();
    initSliders();
    initAnnouncement();
  });
})();
